import { ReactNode } from "react";
import List from "@ingka/list";

import "@ingka/text/dist/style.css";
import "@ingka/list/dist/style.css";

interface FixaListProps {
  size?: "small" | "medium" | "large";
  children: ReactNode;
}

export const FixaList = (props: FixaListProps) => {
  return <List {...props} />;
};
